
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"104","height":"84","viewBox":"0 0 104 84","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 31.2095C4.97431 12.0178 14.2327 -2.88724 36.2078 3.50048C53.136 8.42117 63.9644 31.3135 51.9486 46.3517C49.0696 49.9548 42.6523 49.4009 38.9856 47.3817C33.185 44.1875 31.8031 38.5699 33.4815 32.3426C36.5303 21.0303 49.0442 9.72614 61.3621 13.2862C80.6387 18.8575 90.2193 38.422 92.1749 57.219C92.5644 60.9631 90.7666 89.1008 86.7222 73.8032C85.9882 71.0268 84.1178 62.6319 85.0247 65.3566C86.5284 69.8741 87.1852 72.4751 87.1852 77.357C87.1852 78.3262 86.4776 83.3913 88.6255 81.6318C93.0234 78.029 97.6779 74.7828 102 71.0735","stroke":"#07C03B","stroke-width":"2.5","stroke-linecap":"round"}})])
          )
        }
      }
    